import { useRequest } from 'ahooks';
import { policyQA } from '../../../axios/api'
import {useEffect , useState} from 'react'
import { useNavigate ,useLocation, useSearchParams} from 'react-router-dom';

function usePolicyQa(){
  const [queryArgs, setQueryArgs] = useState({
    "search_id": "1-1-6",
    "quoted_policy" : [],
    "question":"",
    "history":[]
  })
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(()=>{
    try{
        const data = JSON.parse(searchParams.get('files'))
        setQuery({
          quoted_policy:data?.map(item => item.policy_title)
        })
    }catch(e){
        console.log(e)
    }
  },[])

  const {  data:qaData, loading:qaLoading,run } = useRequest(
    async () => {
      try {
        const resp = await policyQA({
          ...queryArgs
        });
        return resp?.data ?? undefined
      } catch (error) {
        // message.error('获取知识点失败！');
        return undefined;
      }
    },
    {
      refreshDeps: [queryArgs],
      debounceWait: 1,
      ready:queryArgs?.quoted_policy?.length === 2
      // manual: true,
    },
  );
  const setQuery = (params) => {
    setQueryArgs((oldValues) => {
      return {
        ...oldValues,
        ...params,
      };
    });
};
  const refresh = () => {
    run()
  };

    return {
      qaData,
      qaLoading,
    
    }
}

export default usePolicyQa